module.exports = __webpack_public_path__ + "img/logo.d56beb48.svg";